import TickIcon from "../assets/tickIcon.png";
import Logo from "../assets/Acord.png";

function formatDate(date, format) {
  const map = {
    mm: date.getMonth() + 1,
    dd: date.getDate(),
    yyyy: date.getFullYear(),
  };
  return format.replace(/mm|dd|yyyy/gi, (matched) => map[matched]);
}
export const handleAuthRedirect = (AdminLogin, navigate) => {
  if (AdminLogin === "Agent") {
    navigate("/main/dashboard");
  } else if (AdminLogin === "User") {
    navigate("/main/user/dashboard");
  }
  // else {
  //   debugger;
  //   navigate("/admin/dashboard");
  // }
};

export const certificate = {
  logo: Logo,
  title: "CERTIFICATE OF LIABILITY INSURANCE",
  headerDescription:
    "THIS CERTIFICATE IS ISSUED AS A MATTER OF INFORMATION ONLY AND CONFERS NO RIGHTS UPON THE CERTIFICATE HOLDER. THIS CERTIFICATE DOES NOT AFFIRMATIVELY OR NEGATIVELY AMEND. EXTEND OR ALTER THE COVERAGE AFFORDED BY POLICIES BELOW. THIS CERTIFICATE OF INSURANCE DOES NOT CONSTITUTE A CONTRACT BETWEEN THE ISSUING INSURANCE(S). AUTHORIZED REPRESENTATIVE OR PROCEDURE AND THE CERTIFICATE HOLDER.",
  headerNote:
    "IMPORTANT: If the certificate holder is an ADDITIONAL INSURED, the policy(ies) must have ADDITIONAL INSURED provisions or be endrosed. If SUBROGATION IS WAIVED, subject to the terms and conditions of the policy. certain policies may require and endorsement. A statement on this certificate does not confer rights to the certificate holder in lieu of such endorsement(s).",
  producer:
    "GoldenEra Insurance Agency 200 Brown Road, STE 203 Fremont, CA 94539 Lic#0M92371",
  insured: "yupup.com",
  tickIcon: TickIcon,
  date: formatDate(new Date(), "mm/dd/yyyy"),
  contactDetails: {
    name: "Daven Loomba",
    phone: "510-270-8141",
    email: "info@goldenerainsurance.com",
    fax: "510-373-1741",
  },
  policyText:
    "THIS IS TO CERTIFY THAT THE POLICIES OF INSURANCE LISTED BELOW HAVE BEEN ISSUED TO THE INSURED NAMED ABOVE FOR THE POLICY PERIOD INDICATED. NOTWITHSTANDING ANY REQUIREMENT, TERM OR CONDITION OF ANY CONTRACT OR OTHER DOCUMENT WITH RESPECT TO WHICH THIS CERTIFICATE MAY ISSUED OR MAT PERTAIN, THE INSURANCE AFFORDED BY THE POLICIES DESCRIBED HEREIN IS SUBJECT TO ALL THE TERMS, EXCLUSIONS AND CONDITIONS OF SUCH POLICIES. LIMITS DOWN MAY HAVE BEEN REDUCED BY PAID CLAIMS.",
  insurer: {
    type: "INSURER(S) AFFORDING COVERAGE ",
    a: {
      title: "Commer Commer",
      value: "16188",
    },
    b: {
      title: "Underwriters at Lloyds, London",
      value: "38917",
    },
    c: {
      title: "",
      value: "",
    },
    d: {
      title: "",
      value: "",
    },
    e: {
      title: "",
      value: "",
    },
    f: {
      title: "",
      value: "",
    },
  },
  generalLiability: {
    claimsMade: false,
    occur: true,
    aggegrateLimit: {
      policy: false,
      project: false,
      loc: false,
      other: false,
    },
    policyNumber: "125456",
    eef: "01/31/2024",
    exp: "10/31/2025",
    limits: {
      eachOccurence: "",
      damageToRentend: "",
      medExp: "",
      advInjury: "",
      aggregate: "",
      products: "",
    },
  },
  automobilityLiability: {
    claimsMade: false,
    occur: true,
    anyAuto: true,
    ownedAutosOnly: false,
    scheduledAutos: true,
    nonAwonedAutos: false,
    hiredAutosOnly: false,
    policyNumber: "BE2017310000",
    eef: "12/30/2023",
    exp: "12/30/2024",
    limits: {
      combineSingleLimit: "1,000,000",
      bodilyInjuryPerPerson: "",
      bodilyInuryPerAccident: "",
      propertyDamagae: "",
    },
  },
  general: {
    umbrellaLiab: true,
    occcur: false,
    excessLiab: false,
    claimsMade: false,
    ded: false,
    retention: "",
    limits: {
      eachOccurence: "",
      aggregate: "",
    },
  },
  workers: {
    executive: true,
    limits: {
      perstatue: "",
      other: "",
      eachAccident: "",
      diseaseEaEmployee: "",
      diseasePolicyLimit: "",
    },
  },
  physicalDamage: {
    policyNumber: "BE2017310000",
    eef: "12/30/2023",
    exp: "12/30/2024",
    limits: {
      collisionDeductible: "",
      comprehansiveDeductible: "",
    },
  },

  motorTruckCargo: {
    policyNumber: "BE2017310000",
    eef: "12/30/2023",
    exp: "12/30/2024",
  },
  formContainerDescription:
    "DESCRIPTION OF OPERATIONS / LOCATIONS / VEHICLES (ACORD 101, Additional Remarks Schedule, may be attached if more space is required)",
  signatureImage:
    "https://coi-media.s3.amazonaws.com/users/09530110-6d3e-40d5-9fe3-f2a4d8189960",
};

export const setToken = (accessToken, refreshToken) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
};
export const getAccessToken = () => {
  return localStorage.getItem("accessToken");
};
export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};
export const removeAccessToken = () => {
  localStorage.removeItem("accessToken");
};
export const removeRefreshToken = () => {
  localStorage.removeItem("refreshToken");
};
export const clearLocalStorage = () => {
  removeAccessToken();
  localStorage.clear();
};
